import buttonFactory from 'sdi/components/button';
import { queryK, dispatchK } from 'sdi/shape/functions';

export const { makeLabelAndIcon } = buttonFactory(
    queryK('component/button'),
    dispatchK('component/button'),
);
